// extracted by mini-css-extract-plugin
export var baseButton = "_q9-0";
export var controlsArrowKeys = "_q9-1";
export var controlsResetButton = "_q9-2";
export var lightGameButton = "_q9-4 _q9-0";
export var playAgainButton = "_q9-5 _q9-0";
export var startGameButton = "_q9-3 _q9-0";